import React from 'react'
import { CBadge, CCard, CCardBody, CFormSwitch, CLoadingButton, CSpinner } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilStar } from '@coreui/icons'

// The on/off panel at the top of the Team of the Round page. While the add-on is off it is the
// whole page: one clear call to switch it on. Once on it shrinks to a status row.
const ActivateTotr = ({ active, loading, toggling, onToggle }) => {
  if (loading) {
    return (
      <CCard className="totr-panel">
        <CCardBody className="d-flex align-items-center gap-2 text-medium-emphasis py-4">
          <CSpinner size="sm" />
          <span>Loading Team of the Round settings...</span>
        </CCardBody>
      </CCard>
    )
  }

  if (!active) {
    return (
      <CCard className="totr-panel">
        <CCardBody className="ge-addon-off">
          <div className="ge-addon-off-icon">
            <CIcon icon={cilStar} size="xxl" />
          </div>
          <h2 className="ge-addon-off-title">Team of the Round is switched off</h2>
          <p className="ge-addon-off-text">
            Switch it on to pick a standout team for each round and award those players bonus
            points. Members won&apos;t see Team of the Round while it is off.
          </p>
          <CLoadingButton color="primary" loading={toggling} onClick={() => onToggle(true)}>
            <CIcon icon={cilStar} className="me-1" />
            Turn On Team of the Round
          </CLoadingButton>
        </CCardBody>
      </CCard>
    )
  }

  return (
    <CCard className="totr-panel">
      <CCardBody className="ge-addon-status">
        <div className="ge-stat-icon ge-stat-icon--success">
          <CIcon icon={cilStar} size="lg" />
        </div>
        <div className="flex-grow-1">
          <div className="d-flex align-items-center gap-2">
            <h2 className="totr-panel-title">Team of the Round</h2>
            <CBadge color="success" shape="rounded-pill">
              Active
            </CBadge>
          </div>
          <p className="totr-panel-note">
            Members can see Team of the Round. Switching off hides it but keeps every team and point
            you have set up.
          </p>
        </div>
        <CFormSwitch
          size="lg"
          id="is_totr_activate"
          label="On"
          checked
          disabled={toggling}
          onChange={(e) => onToggle(e.target.checked)}
        />
      </CCardBody>
    </CCard>
  )
}

export default ActivateTotr
